import React, { useEffect, useState, useRef } from 'react';
import { Box, SimpleGrid, useToast, Flex, Button } from '@chakra-ui/react';
import DynamicTable from '../../../components/table/DynamicTable.js';
import { columnsDataStudents } from './variables/columnsDataStudents.js';
import { getData, postData } from '../../../utils/httpClient.js';
import { normalizeDocument } from '../../../utils/documentFormat';
import { useSearch } from '../../../contexts/SearchContext.js';
import CreateModal from '../../../components/students/CreateModal.js';
import ConfirmModal from '../../../components/modal/ConfirmModal.js';

const initialFormData = {
  name: '',
  secondName: '',
  lastName: '',
  maternalLastName: '',
  documentTypeId: '',
  document: '',
  birthDate: '',
  sexId: '',
  phone: '',
  cellPhone: '',
  email: '',
  street: '',
  number: '',
  apartment: '',
  city: '',
  locality: '',
  country: '',
  emergencyContact: '',
  emergencyContactPhone: '',
  medicalInsurance: '',
  mobileEmergency: '',
  school: '',
  orientation: '',
  form_69A: false,
  issued_by: '',
  last_exam_date: '',
  department: '',
  photo: null,
};

export default function Settings() {
  const { searchQuery, updateSearchQuery } = useSearch();
  const [data, setData] = useState([]);
  const [page, setPage] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const [modalState, setModalState] = useState({
    isOpen: false,
    confirmModalOpen: false,
  });

  const [formData, setFormData] = useState(initialFormData);

  const rowsPerPage = 10;
  const toast = useToast();

  const latestRequestRef = useRef(0);

  const getStudents = async (dato) => {
    const requestId = ++latestRequestRef.current;
    try {
      const response = await getData(
        `/person/student?page=${page + 1}&limit=${rowsPerPage}&data=${dato}`,
      );
      if (requestId !== latestRequestRef.current) return;
      setData(response?.payload?.people || []);
      setTotalPages(Math.ceil(response?.payload?.total / rowsPerPage));
    } catch (error) {
      if (requestId !== latestRequestRef.current) return;
      toast({
        title: 'Error al obtener estudiantes',
        status: 'error',
        duration: 3000,
        isClosable: true,
      });
    }
  };

  const createPostData = (formData) => {
    return {
      name: formData.name,
      secondName: formData.secondName,
      lastName: formData.lastName,
      maternalLastName: formData.maternalLastName,
      documentTypeId: formData.documentTypeId, // 1 para DNI, 2 para Pasaporte
      document: normalizeDocument(formData.document),
      phone: formData.phone,
      cellPhone: formData.cellPhone,
      email: formData.email,
      birthPlace: '', // Aquí puedes asignar un valor si es necesario
      birthDate: formData.birthDate,
      sexId: formData.sexId, // 1 para masculino, 2 para femenino, etc.
      profession: '', // Aquí puedes asignar un valor si es necesario
      workPhone: '', // Aquí puedes asignar un valor si es necesario
      emergencyContact: formData.emergencyContact,
      emergencyContactPhone: formData.emergencyContactPhone,
      medicalInsurance: formData.medicalInsurance,
      mobileEmergency: formData.mobileEmergency,
      photo: formData.photo,

      // Direcciones
      address: {
        street: formData.street,
        number: formData.number,
        apartment: formData.apartment,
        zipCode: '', // Aquí puedes asignar un valor si es necesario
        city: formData.city,
        country: formData.country,
        locality: formData.locality,
      },

      student: {
        // Información Académica
        school: formData.school,
        orientation: formData.orientation,
        form_69A: formData.form_69A?.split(",")[1], // Este valor será un booleano
        issuedBy: formData.issued_by,
        lastExamDate: formData.last_exam_date,
        department: formData.department,
      },
    };
  };

  const createStudent = async () => {
    try {
      const newStudent = createPostData(formData);
      console.log(newStudent);
      const response = await postData('/person/register', newStudent);
      if (response?.payload) {
        toast({
          title: 'Estudiante creado con éxito',
          status: 'success',
          duration: 3000,
          isClosable: true,
        });
        closeModal();
      }
    } catch (error) {
      toast({
        title: 'Error al crear estudiante',
        status: 'error',
        duration: 3000,
        isClosable: true,
      });
    }
  };

  useEffect(() => {
    getStudents(searchQuery);
  }, [page, searchQuery]);

  const resetForm = () => {
    setFormData(initialFormData);
  };

  const openModal = () => {
    setModalState({
      isOpen: true,
      confirmModalOpen: false,
    });
  };

  const closeModal = () => {
    setModalState({
      isOpen: false,
      confirmModalOpen: false,
    });
    resetForm();
  };

  const showConfirmModal = () => {
    setModalState({
      isOpen: true,
      confirmModalOpen: true,
    });
  };

  const hiddeConfirmModal = () => {
    setModalState({
      isOpen: true,
      confirmModalOpen: false,
    });
  };

  const handleConfirm = async () => {

    await createStudent();
    closeModal();
    await getStudents();
  };

  return (
    <Box pt={{ base: '130px', md: '80px', xl: '80px' }}>
      <Flex justify="flex-end" mb={4}>
        <Button colorScheme="blue" onClick={() => openModal()}>
          Nuevo Estudiante
        </Button>
      </Flex>
      <SimpleGrid
        mb="20px"
        columns={{ sm: 1 }}
        spacing={{ base: '20px', xl: '20px' }}
      >
        <DynamicTable
          columnsData={columnsDataStudents}
          data={data}
          page={page}
          setPage={setPage}
          totalPages={totalPages}
          openModal={openModal}
          showRowInfo={true}
        />
      </SimpleGrid>

      <CreateModal
        isOpen={modalState.isOpen}
        onClose={showConfirmModal}
        formData={formData}
        setFormData={setFormData}
        onConfirm={handleConfirm}
      />

      <ConfirmModal
        isOpen={modalState.confirmModalOpen}
        onClose={hiddeConfirmModal}
        onConfirm={closeModal}
        header="Confirmación de Cancelación"
        message="¿Estás seguro de que deseas cancelar? Todos los datos no guardados se perderán."
      />
    </Box>
  );
}
